/**
 * API 相關類型定義
 */

// API 請求選項
export interface ApiRequestOptions extends RequestInit {
  authenticated?: boolean;
  params?: Record<string, string | number | boolean | undefined>;
}

// API 錯誤類型
export class ApiError extends Error {
  status: number;
  data: any;

  constructor(message: string, status: number, data?: any) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

// API 端點類型
export type ApiEndpoint = string | ((...args: any[]) => string);
